import { useEffect } from "react";

// Adds `.revealed` to elements with `.reveal-on-scroll` or `.reveal-clip`
// when they enter the viewport. Re-scans whenever `dep` changes (route change).
export default function useScrollReveal(dep) {
  useEffect(() => {
    const selector = ".reveal-on-scroll, .reveal-media";

    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(selector).forEach((el) => el.classList.add("revealed"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -8% 0px" }
    );

    const t = setTimeout(() => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el.classList.contains("revealed")) io.observe(el);
      });
    }, 60);

    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, [dep]);
}
